import React, {Component} from 'react';
import Consoles from '../../components/Consoles/Consoles';

class Turntable extends Component {

    render(){
        return <Consoles />
    }
}

export default Turntable;